import type {ModuleSpecField} from '../designer/specTypes';
export type ComputedRatioProposal={accepted:false;entity:string;field:string;before:string;formula:string;total:string;ready:boolean};
/** Recognize only the literal twenty-question shortcut; never rewrite an arbitrary Maker formula. */
export function computedRatioProposals(entities:Record<string,{fields:ModuleSpecField[]}>):ComputedRatioProposal[]{
 const result:ComputedRatioProposal[]=[];
 for(const [entity,{fields}]of Object.entries(entities)){
  const score=fields.find(f=>f.name==='score'&&f.type==='number');
  if(!score)continue;
  const totals=fields.filter(f=>['nombre_questions','question_count'].includes(f.name)&&f.type==='number');
  if(totals.length>1)continue;
  const total=totals[0]?.name??'nombre_questions';
  for(const field of fields)if(field.computed&&/^score\s*\*\s*5$/.test(field.computed.formula.trim()))result.push({accepted:false,entity,field:field.name,before:field.computed.formula,formula:`score / ${total} * 100`,total,ready:totals.length===1});
 }
 return result;
}
